import React from "react";
import "./colorPicker.css";

export default function ColorPicker({ value, onChange: _onChange, onBlur }) {
  return (
    <div className="colorPicker">
      <label
        className="colorPickerLabel"
        value={value}
        for="colors"
        style={{ background: value }}
      />
      {/* <p>{value}</p> */}
      <input
        type="color"
        id="colors"
        className="colorPickerInput"
        value={value}
        name="color"
        onChange={(evt) => {
          _onChange(evt.target.value);
        }}
        onBlur={onBlur}
      />
      <input
        type="text"
        id="colors"
        className="colorPickerInputsText drop-shadow-2xl"
        value={value}
        name="color"
        onChange={(evt) => {
          _onChange(evt.target.value);
        }}
        onBlur={onBlur}
      />
    </div>
  );
}
